export const EDITING_CHANGE_COURSE_MANAGEMENT = 'EDITING_CHANGE_COURSE_MANAGEMENT';

export const EDITING_CHANGE_CLASS_MANAGEMENT = 'EDITING_CHANGE_CLASS_MANAGEMENT';

export const ACTION_TOOL_BOOK_STATEMENT_COURSE_LIST = 'ACTION_TOOL_BOOK_STATEMENT_COURSE_LIST';

export const ACTION_TOOL_BOOK_STATEMENT_COURSE_CATALOG_LIST = 'ACTION_TOOL_BOOK_STATEMENT_COURSE_CATALOG_LIST';

export const ACTION_TOOL_CHANGE_BOOK_STATEMENT_COURSE_LIST = 'ACTION_TOOL_CHANGE_BOOK_STATEMENT_COURSE_LIST';


// WEBPACK FOOTER //
// ./src/store/Admin/modules/courseManagement/types.js